<template>
    <li
        class="select2-results__option font-weight-normal"
        :style="disabled ? 'pointer-events: none; opacity: 0.5; cursor: initial' : ''"
        :aria-selected="seleted"
        >{{ text }}
    </li>
</template>
<script>
export default {
    name: 'SelectOption',
    props: {
        text: {
            type: [String, Number],
            default: () => translate('components.button_select.default_text')
        },
        seleted: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style scoped>
.select2-results__option:hover {
    background: #f5f5f5;
}
.select2-results__option[aria-selected=true]:hover {
    background: #26a69a;
}
</style>
